// extracted by mini-css-extract-plugin
export default {"convertingPopup":"purchase-success_convertingPopup__myn-w","animation":"purchase-success_animation__a+BDH"};